var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMall(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6336",
    "data-name": "Rectangle 6336",
    width: 40,
    height: 44.173,
    fill: "#c8d1ec"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34918",
    "data-name": "Group 34918",
    transform: "translate(-4661 -5526)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6346",
    "data-name": "Rectangle 6346",
    width: 74,
    height: 74,
    rx: 12,
    transform: "translate(4661 5526)",
    fill: "#f1f5ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_34901",
    "data-name": "Group 34901",
    transform: "translate(4678 5541)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34886",
    "data-name": "Group 34886",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24422",
    "data-name": "Path 24422",
    d: "M1.023,44.173A1.674,1.674,0,0,1,0,42.372c.041-.817,0-1.638.01-2.458A1.392,1.392,0,0,1,1.551,38.4H2.5V37.86q0-5.088,0-10.177c0-1.433.616-2.056,2.036-2.056h.7v-.534q0-7.783,0-15.567c0-.947.224-1.172,1.162-1.173h4.357c.008-.174.02-.325.02-.476q0-3.191,0-6.382A1.333,1.333,0,0,1,12.258,0H28.213A1.327,1.327,0,0,1,29.7,1.488q.007,3.148,0,6.3v.548c.194.009.347.021.5.021,1.308,0,2.616,0,3.924,0,.876,0,1.132.255,1.132,1.127q0,7.783,0,15.567v.58h.865a1.682,1.682,0,0,1,1.842,1.849q.006,5.174,0,10.349v.57c.229,0,.425,0,.619,0a1.351,1.351,0,0,1,1.4,1.346c.03,1.034.019,2.07,0,3.1a1.5,1.5,0,0,1-1,1.326ZM36.588,38.38V27.654c0-.631-.016-.647-.662-.647H4.532c-.626,0-.654.03-.654.661q0,5.132,0,10.264v.429H6.239v-.55c0-1.783,0-3.565,0-5.348,0-.962.447-1.4,1.393-1.4q2.653,0,5.3,0a1.214,1.214,0,0,1,1.369,1.383q0,2.74,0,5.477v.456h1.9V37.89q0-2.717,0-5.434a1.223,1.223,0,0,1,1.4-1.4q2.567,0,5.133,0c1.15,0,1.539.393,1.54,1.561q0,2.631,0,5.261c0,.165.014.329.022.487h1.87V37.82c0-1.8,0-3.594,0-5.391a1.213,1.213,0,0,1,1.382-1.372q2.631,0,5.261,0c.981,0,1.423.441,1.424,1.417q0,2.717,0,5.434v.473ZM28.291,1.4H12.183V16.792H28.291ZM1.415,42.769H38.58V39.8H1.415ZM28.115,25.6h5.738V14.508H29.732c-.01.135-.026.248-.027.36,0,.662.011,1.323-.007,1.984a1.3,1.3,0,0,1-1.289,1.342c-.094.007-.189.016-.294.025Zm-21.486,0h5.739V18.229c-1.269-.156-1.6-.528-1.6-1.793V14.514H6.629Zm7.179,0h5.721V18.214H13.808Zm7.145,0h5.74V18.225h-5.74ZM7.651,38.36h5.256v-5.9H7.651Zm15.212-5.9H17.608v5.918h5.254Zm4.718,5.9h5.257v-5.9H27.58ZM33.856,9.769h-4.11v3.3h4.11Zm-27.224,3.3h4.116V9.762H6.612c0,.988,0,1.948,0,2.908,0,.127.012.253.019.4",
    transform: "translate(0 0)",
    fill: "#c8d1ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24423",
    "data-name": "Path 24423",
    d: "M23.845,4.8c.259,0,.516-.014.772,0A.954.954,0,0,1,25.6,5.8q.021,3.407,0,6.813a.936.936,0,0,1-1,1.007q-3.578.021-7.157,0a.918.918,0,0,1-.976-1.022q-.01-3.364,0-6.727A.964.964,0,0,1,17.493,4.8a3.622,3.622,0,0,1,.431,0c.215.017.315-.052.392-.28a2.837,2.837,0,0,1,5.424.015c.027.08.061.158.1.267m-5.989,7.414H24.2V6.206h-6.34Zm4.511-7.446a1.452,1.452,0,0,0-1.441-.861,1.4,1.4,0,0,0-1.231.861Z",
    transform: "translate(-0.786 -0.121)",
    fill: "#c8d1ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24424",
    "data-name": "Path 24424",
    d: "M21.124,10.41a2.856,2.856,0,0,1-2.842-2.674c-.016-.518.215-.828.635-.852s.691.249.74.768a1.411,1.411,0,0,0,1.019,1.3,1.355,1.355,0,0,0,1.543-.461,2.488,2.488,0,0,0,.35-.9c.1-.478.346-.739.753-.7a.718.718,0,0,1,.624.868,2.861,2.861,0,0,1-2.823,2.657",
    transform: "translate(-0.873 -0.328)",
    fill: "#c8d1ec"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMall);
export default __webpack_public_path__ + "static/media/mall.0ddc02cce2c64f1f74b9bb1004ed905f.svg";
export { ForwardRef as ReactComponent };